<script>
  import * as restfulService from '../../../services/restfulService'

  import bus from '@utils/bus'
  import {get, set} from '@utils/storage'
  import helpers from '@mixins/helper'

  export default {
    mixins: [helpers],
    name: 'dashboard-popup',
    data () {
      return {
        popup: {
          id: null,
          nome: '',
          imagem: '',
          texto: ''
        },
        popupId: '',
        mostrarModal: false
      }
    },
    mounted () {
      this.buscarPopup()
    },
    computed: {
      modalIdStorage: async function () {
        return parseInt(await get('hidePopup') || 'null')
      },
      isMobileSize: function () {
        return this.isMobile().any()
      }
    },
    watch: {
      mostrarModal: function (newValue, oldValue) {
        if (oldValue && !newValue) {
          set('hidePopup', this.popup.id)
          bus.$emit('fechouModal', true)
        }
      }
    },
    methods: {
      buscarPopup () {
        restfulService.get('dashboard', 'popup')
          .then(response => {
            if (response.imagem || response.texto) {
              this.popup = response
              if (this.modalIdStorage !== response.id) {
                this.mostrarModal = true
              }
              bus.$emit('existeModal', this.mostrarModal)
            }
          })
          .catch(e => {
            console.log(e)
          })
      }
    }
  }
</script>

<template>
    <v-dialog v-model="mostrarModal"
              :width="isMobileSize ? '80%' : '50%'">
        <v-card class="popup-modal">
            <template v-if="!popup.texto">
              <a v-if="popup.link" :href="popup.link" target="_blank">
                  <img :src="popup.imagem" alt="">
              </a>
              <img v-if="!popup.link" :src="popup.imagem" alt="">
            </template>
            <div v-if="popup.texto" v-html="popup.texto" style="padding: 20px"></div>
            <v-divider></v-divider>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn flat @click="mostrarModal = false">Fechar</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>



// WEBPACK FOOTER //
// Main.vue?b886c990